// ConfirmModal.jsx - Generic confirm/cancel dialog, styled like StaffLeaveModal/SalonClosureModal.
import React from 'react';
import '../pages/salon/SalonStaffManagement.css';

function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content modal-content-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button type="button" className="cancel-modal-btn" onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className={danger ? 'confirm-danger-btn' : 'save-modal-btn'} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
